import Modifier from 'ember-modifier';
import { isDestroying, registerDestructor } from '@ember/destroyable';

const cleanup = (instance) => {
  if (instance.taxFormCallback) {
    window.removeEventListener('message', instance.taxFormCallback);
  }
};

class TaxFormModifier extends Modifier {
  #initialized = false;

  constructor(props) {
    super(props);
    registerDestructor(this, cleanup);
  }

  modify(element) {
    if (this.#initialized) {
      return;
    }

    this.#initialized = true;

    /**
     * @see https://support.tipalti.com/Content/Topics/Development/iFrames/SetSizeOfPayeeIframe.htm
     */
    window.addEventListener('message', this.taxFormCallback = (event) => {
      if (event.data && event.data.TipaltiIframeInfo) {
        console.log(`height: ${event.data.TipaltiIframeInfo.height} width: ${event.data.TipaltiIframeInfo.width}`);
        element.style.height = `${event.data.TipaltiIframeInfo.height + 20}px`;
      }
    });
  }
}

export default TaxFormModifier;
